import { render, staticRenderFns } from "./RoleUpload.vue?vue&type=template&id=729d3361&scoped=true"
import script from "./RoleUpload.vue?vue&type=script&lang=js"
export * from "./RoleUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729d3361",
  null
  
)

export default component.exports